import { createSlice } from "@reduxjs/toolkit";

const initialObjectsState = {
  //name:"",
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  objectForEdit: undefined,
  lastError: null,
  lastMsg: null,
  selectedIds: [],
  saveCount: 0,
  errorCount: 0,
  errors: [],
};
export const callTypes = {
  list: "list",
  action: "action"
};


export const objectsSlice = ({ name = "" }) => {
  const slice = createSlice(
    {
      name: name,
      initialState: { name, ...initialObjectsState },
      reducers: {
        catchError: (state, action) => {
          state.lastError = `${action.type}: ${action.payload.error}`;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = false;
          } else {
            state.actionsLoading = false;
          }
        },
        startCall: (state, action) => {
          state.error = null;
          if (action.payload.callType === callTypes.list) {
            state.listLoading = true;
          } else {
            state.actionsLoading = true;
          }
        },
        // getObjectById
        objectFetched: (state, action) => {
          state.actionsLoading = false;
          state.objectForEdit = action.payload.objectForEdit;
          state.error = null;
        },
        errorListFetched: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          state.saveCount = action.payload.saveCount;
          state.errorCount = action.payload.errorCount;
          state.errors = action.payload.errors;
        },

        // findObjects
        objectsFetched: (state, action) => {
          const { totalCount, entities } = action.payload;
          state.listLoading = false;
          state.error = null;
          state.entities = entities;
          state.totalCount = totalCount;
        },
        // fetchAllObjects
        allObjectsFetched: (state, action) => {
          const { entities } = action.payload;
          state.error = null;
          state.entities = entities;
        },
        // createObject
        objectCreated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          if (state.entities) {
            state.entities.push(action.payload.object);
          }
          if (action.payload.object.errors && action.payload.object.errors.length > 0) {
            state.saveCount = action.payload.object.saveCount;
            state.errorCount = action.payload.object.errorCount;
            state.errors = action.payload.object.errors;
          }
          state.lastMsg = "رکورد جدید با موفقیت ایجاد شد.";
        },
        objectsCreated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          if (state.entities) {
            state.entities.push(action.payload.objects);
          }
          state.lastMsg = "رکوردهای جدید با موفقیت ایجاد شد.";
        },
        // updateObject
        objectUpdated: (state, action) => {
          state.error = null;
          state.actionsLoading = false;
          if (state.entities) {
            state.entities = state.entities.map(entity => {
              if (entity.id === action.payload.object.id) {
                return action.payload.object;
              }
              return entity;
            });
          }

          if (action.payload.object.errors && action.payload.object.errors.length > 0) {
            state.saveCount = action.payload.object.saveCount;
            state.errorCount = action.payload.object.errorCount;
            state.errors = action.payload.object.errors;
          }
          state.lastMsg = "رکورد مورد نظر با موفقیت ویرایش شد.";
        },
        // deleteObject
        objectDeleted: (state, action) => {
          state.error = null;
          state.actionsLoading = false;
          state.entities = state.entities.filter(el => el.id !== action.payload.id);
          state.lastMsg = "رکورد مورد نظر با موفقیت حذف شد.";
        },
        // deleteObjects
        objectsDeleted: (state, action) => {
          state.error = null;
          state.actionsLoading = false;
          state.entities = state.entities.filter(
            el => !action.payload.ids.includes(el.id)
          );
          state.lastMsg = "رکوردهای مورد نظر با موفقیت حذف شد.";
        },
        objectsUpdated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          const { ids, object } = action.payload;
          state.entities = state.entities.map(entity => {
            if (ids.findIndex(id => id === entity.id) > -1) {
              entity = { entity, ...object }
            }
            return entity;
          });
          state.lastMsg = "رکوردهای مورد نظر با موفقیت به روز رسانی شدند.";
        },
        // objectsUpdateState
        objectsStatusUpdated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          const { ids, isDeleted } = action.payload;
          state.entities = state.entities.map(entity => {
            if (ids.findIndex(id => id === entity.id) > -1) {
              entity.isDeleted = isDeleted;
            }
            return entity;
          });
          state.lastMsg = "وضعیت رکوردهای مورد نظر با موفقیت به روز رسانی شد.";
        },
        // objectsUpdateAllowed
        objectsAllowedUpdated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          const { ids, allowed } = action.payload;
          state.entities = state.entities.map(entity => {
            if (ids.findIndex(id => id === entity.id) > -1) {
              entity.allowed = allowed;
            }
            return entity;
          });
          state.lastMsg = "اجازه دسترسی رکوردهای مورد نظر با موفقیت به روز رسانی شد.";
        },
        // objectsUpdateAllowed
        objectsFullAccessUpdated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          const { ids, isFullAccess } = action.payload;
          state.entities = state.entities.map(entity => {
            if (ids.findIndex(id => id === entity.id) > -1) {
              entity.isFullAccess = isFullAccess;
            }
            return entity;
          });
          state.lastMsg = "سطح دسترسی رکوردهای مورد نظر با موفقیت به روز رسانی شد.";
        },
        // objectsUpdateHoliday
        objectsHolidayUpdated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          const { ids, holiday } = action.payload;
          state.entities = state.entities.map(entity => {
            if (ids.findIndex(id => id === entity.id) > -1) {
              entity.holiday = holiday;
            }
            return entity;
          });
          state.lastMsg = "وضعیت رکوردهای مورد نظر با موفقیت به روز رسانی شد.";
        },
        objectsSelectedUpdated: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          const { ids, isSelected } = action.payload;
          state.entities = state.entities.map(entity => {
            if (ids.findIndex(id => id === entity.id) > -1) {
              entity.isSelected = isSelected;
            }
            return entity;
          });
          state.lastMsg = "وضعیت رکوردهای مورد نظر با موفقیت به روز رسانی شد.";
        },
        setSelectedObjects: (state, action) => {
          state.actionsLoading = false;
          state.error = null;
          // state.selectedIds = []
          state.selectedIds = action.payload.ids
          // if (state.entities && action.payload.ids) {
          //   state.entities = state.entities.map(entity => {
          //     if (action.payload.ids.findIndex(id => id === entity.id) > -1) {
          //       entity.isSelected = true;
          //     }
          //     else {
          //       entity.isSelected = false;
          //     }
          //     return entity;
          //   });
          // }
          // state.lastMsg = "رکوردهای مورد نظر با موفقیت به روز رسانی شدند.";
        },
      }
    });
  return slice;
};

// export const objectsSlice = createSlice(
//   {
//   name: "objects",
//   initialState: initialObjectsState,
//   reducers: {
//     catchError: (state, action) => {
//       state.error = `${action.type}: ${action.payload.error}`;
//       if (action.payload.callType === callTypes.list) {
//         state.listLoading = false;
//       } else {
//         state.actionsLoading = false;
//       }
//     },
//     startCall: (state, action) => {
//       state.error = null;
//       if (action.payload.callType === callTypes.list) {
//         state.listLoading = true;
//       } else {
//         state.actionsLoading = true;
//       }
//     },
//     // getObjectById
//     objectFetched: (state, action) => {
//       state.actionsLoading = false;
//       state.objectForEdit = action.payload.objectForEdit;
//       state.error = null;
//     },
//     // findObjects
//     objectsFetched: (state, action) => {
//       const { totalCount, entities } = action.payload;
//       state.listLoading = false;
//       state.error = null;
//       state.entities = entities;
//       state.totalCount = totalCount;
//     },
//     // createObject
//     objectCreated: (state, action) => {
//       state.actionsLoading = false;
//       state.error = null;
//       state.entities.push(action.payload.object);
//     },
//     // updateObject
//     objectUpdated: (state, action) => {
//       state.error = null;
//       state.actionsLoading = false;
//       state.entities = state.entities.map(entity => {
//         if (entity.id === action.payload.object.id) {
//           return action.payload.object;
//         }
//         return entity;
//       });
//     },
//     // deleteObject
//     objectDeleted: (state, action) => {
//       state.error = null;
//       state.actionsLoading = false;
//       state.entities = state.entities.filter(el => el.id !== action.payload.id);
//     },
//     // deleteObjects
//     objectsDeleted: (state, action) => {
//       state.error = null;
//       state.actionsLoading = false;
//       state.entities = state.entities.filter(
//         el => !action.payload.ids.includes(el.id)
//       );
//     },
//     // objectsUpdateState
//     objectsStatusUpdated: (state, action) => {
//       state.actionsLoading = false;
//       state.error = null;
//       const { ids, status } = action.payload;
//       state.entities = state.entities.map(entity => {
//         if (ids.findIndex(id => id === entity.id) > -1) {
//           entity.status = status;
//         }
//         return entity;
//       });
//     }
//   }
// });


